var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMedal1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 2H14V11C14 11.5523 13.5523 12 13 12H12.75V14.8637L14.0808 14.0508C14.3428 13.8907 14.6615 14.1331 14.597 14.4433L14.1284 16.6996C14.1017 16.8281 14.1431 16.9618 14.2369 17.0493L15.883 18.5863C16.1094 18.7977 15.9876 19.1898 15.6859 19.2215L13.4911 19.4522C13.366 19.4653 13.2574 19.5479 13.2068 19.6683L12.319 21.782C12.197 22.0727 11.803 22.0727 11.681 21.782L10.7932 19.6683C10.7426 19.5479 10.634 19.4653 10.5089 19.4522L8.31415 19.2215C8.01236 19.1898 7.89063 18.7977 8.11697 18.5863L9.76308 17.0493C9.85686 16.9618 9.89835 16.8281 9.87165 16.6996L9.40298 14.4433C9.33854 14.1331 9.65723 13.8907 9.91919 14.0508L11.25 14.8637V12H11C10.4477 12 10 11.5523 10 11V2Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17 9H15.5V2H17C17.5523 2 18 2.44772 18 3V8C18 8.55228 17.5523 9 17 9Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 2H7C6.44772 2 6 2.44772 6 3V8C6 8.55228 6.44771 9 7 9H8.5V2Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedal1);
export default __webpack_public_path__ + "static/media/medal-1.27c5b97f5f4c8ca2bc6a307a2b387df0.svg";
export { ForwardRef as ReactComponent };